import { ChangeDetectionStrategy, Component, Inject, inject, signal } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatTooltipModule } from '@angular/material/tooltip'
import { LayerIntegrationDeletePayload } from '@core/models/layers.model'
import { LayersClonedService } from '@core/services/layers-cloned.service'

@Component({
  selector: 'app-dialog-delete-integration',
  templateUrl: './dialog-delete-integration.component.html',
  styleUrl: './dialog-delete-integration.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    // Forms
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,

    // Material
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
  ],
})
export class DialogDeleteIntegrationComponent {
  readonly dialogRef = inject(MatDialogRef<DialogDeleteIntegrationComponent>)
  private readonly _layersClonedService = inject(LayersClonedService)

  isLoading$ = signal<boolean>(false)

  constructor(@Inject(MAT_DIALOG_DATA) public data: LayerIntegrationDeletePayload) {}

  async deleteRepoIntegration() {
    if (!this.data.repoName || !this.data.layerName) {
      return
    }

    this.isLoading$.set(true)

    try {
      await this._layersClonedService.deleteRepoIntegration(this.data.repoName, this.data.layerName)
      this.dialogRef.close(true)
    } finally {
      this.isLoading$.set(false)
    }
  }
}
